<div class="modalForm">
  <div class="flex flex-column gap-2 mb-3">
    <app-button
      buttonText="device_management.import.example_file"
      (click)="downloadExample()"
    ></app-button>
  </div>
  <div>
    <p-fileUpload
      (onSelect)="onFileSelect($event)"
      accept="text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      [chooseLabel]="translate.instant('common.choose_file')"
      [showUploadButton]="false"
      [showCancelButton]="false"
      class="w-full"
      styleClass="customFileUpload"
    >
      <ng-template #content let-uploadedFiles>
        @if (uploadedFiles.length > 0) { {{ uploadedFiles.length }} {{
        "common.files_selected" | translate }} }
      </ng-template>
    </p-fileUpload>
  </div>
  @if(failedCsvFilename()) {
  <div class="mt-3 mb-3" style="grid-column: 1/3">
    <p-message severity="warn" styleClass="static">
      {{ "device_management.import.download_failed_import" | translate }}
      <a (click)="downloadFailedFile(failedCsvFilename())"
        >{{ "common.here" | translate }}</a
      >
    </p-message>
  </div>
  }
  <!-- Buttons: -->
  <div class="flex justify-content-end gap-2 dialogBtnGroup">
    <app-button
      id="closeFileDialog"
      buttonText="common.cancel"
      (click)="closeDialog()"
    ></app-button>
    @if (timeoutImport()) {
    <app-timeout></app-timeout>
    } @else {
    <app-button
      id="saveFileButton"
      buttonText="common.save"
      [loading]="loadingImport()"
      (click)="save()"
    ></app-button>
    }
  </div>
</div>
